import { render, staticRenderFns } from "./FulfillmentDetail.vue?vue&type=template&id=27777313&"
import script from "./FulfillmentDetail.vue?vue&type=script&lang=js&"
export * from "./FulfillmentDetail.vue?vue&type=script&lang=js&"
import style0 from "./FulfillmentDetail.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports